export const getPercentChange = (current, previous) => {
    if (!previous) return null;
    return ((current - previous) / previous * 100).toFixed(1);
  };

export const axisStyle = {
  tick: { fontSize: 10, fill: '#94a3b8' },
  tickLine: false,
  axisLine: { stroke: '#e2e8f0', strokeWidth: 1 },
  width: 25
};